<script lang="ts">
	import Notification from '$lib/components/notifications/Notification.svelte';
	import { notification, removeNotification } from '$lib/components/notifications/notifications';
	import { fly } from 'svelte/transition';
</script>

{#if $notification}
	{#key $notification}
		<div
			class="z-notification position-fixed bottom-0 z-10"
			transition:fly|global={{ y: 100, duration: 500 }}
		>
			<Notification
				notification={$notification}
				onClose={() => {
					removeNotification($notification);
				}}
			/>
		</div>
	{/key}
{/if}

<style>
	div {
		left: 50%;
		transform: translateX(-50%);
	}
</style>
